import React from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
// import "./EditModal.css";

interface EditModalProps {
  show: boolean;
  editRow: any | null;
  editableValue: string;
  onEditableValueChange: (value: string) => void;
  onSave: () => void;
  onClose: () => void;
  isSaving?: boolean;
}

const EditModal: React.FC<EditModalProps> = ({
  show,
  editRow,
  editableValue,
  onEditableValueChange,
  onSave,
  onClose,
  isSaving = false,
}) => {
  const commonInputStyle = {
    fontSize: "0.8rem",
    minHeight: 38,
    padding: "0.375rem 0.75rem",
  };

  const commonLabelStyle = {
    fontSize: "0.8rem",
    marginBottom: 6,
    marginTop: 12,
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: { reorderLevel: editableValue || "" },
    validationSchema: Yup.object({
      reorderLevel: Yup.string()
        .required("Reorder Level is required")
        .matches(/^\d+(\.\d+)?$/, "Enter a valid number"),
    }),
    onSubmit: async (values) => {
      // keep parent in sync
      onEditableValueChange(values.reorderLevel);
      await onSave();
    },
  });

  return (
    <Modal show={show} onHide={onClose} centered className="edit-modal-custom" size="lg">
      <Modal.Header className="edit-modal-header" closeButton>
        <Modal.Title className="edit-modal-title">Update Reorder Level</Modal.Title>
      </Modal.Header>
      <Modal.Body className="edit-modal-body">
        {editRow ? (
          <Form autoComplete="off" onSubmit={formik.handleSubmit} noValidate>
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group>
                  <Form.Label className="fw-semibold" style={commonLabelStyle}>
                    Item Name
                  </Form.Label>
                  <Form.Control value={editRow?.item_name || "-"} readOnly style={commonInputStyle} />
                </Form.Group>
              </Col>
                <Col md={6}>
                <Form.Group>
                  <Form.Label className="fw-semibold" style={commonLabelStyle}>
                    Item Code
                  </Form.Label>
                  <Form.Control value={editRow?.item_code || "-"} readOnly style={commonInputStyle} />
                </Form.Group>
              </Col>
           
            </Row>

            <Row className="mb-3">
                 <Col md={6}>
                <Form.Group>
                  <Form.Label className="fw-semibold" style={commonLabelStyle}>
                    Category
                  </Form.Label>
                  <Form.Control value={editRow?.category_name || "-"} readOnly style={commonInputStyle} />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label className="fw-semibold" style={commonLabelStyle}>
                    Sub Category
                  </Form.Label>
                  <Form.Control value={editRow?.sub_category_name || "-"} readOnly style={commonInputStyle} />
                </Form.Group>
              </Col>
              
            </Row>

            <Row className="mb-3">
              {/* <Col md={6}>
                <Form.Group>
                  <Form.Label className="fw-semibold" style={commonLabelStyle}>
                    Total Stock
                  </Form.Label>
                  <Form.Control value={String(editRow?.available_stock ?? "-")} readOnly style={commonInputStyle} />
                </Form.Group>
              </Col> */}
            <Col md={6}>
                <Form.Group>
                  <Form.Label className="fw-semibold" style={commonLabelStyle}>
                    Unit
                  </Form.Label>
                  <Form.Control value={editRow?.unit_name || "-"} readOnly style={commonInputStyle} />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label className="fw-semibold" style={commonLabelStyle}>
                    Reorder Level <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="number"
                    name="reorderLevel"
                    value={formik.values.reorderLevel}
                    onChange={(e: any) => {
                      formik.setFieldValue("reorderLevel", e.target.value);
                      onEditableValueChange(e.target.value);
                    }}
                    onBlur={formik.handleBlur}
                    isInvalid={!!formik.errors.reorderLevel && formik.touched.reorderLevel}
                    style={commonInputStyle}
                    className="form-control-placeholder"
                  />
                  <Form.Control.Feedback type="invalid" style={{ color: "#dc3545" }}>
                    {formik.touched.reorderLevel && formik.errors.reorderLevel}
                  </Form.Control.Feedback>
                  <Form.Text className="text-muted small-text">Only Reorder Level is editable.</Form.Text>
                </Form.Group>
              </Col>
            </Row>

        
          </Form>
        ) : null}
      </Modal.Body>
      <Modal.Footer className="edit-modal-footer">
        <Button variant="secondary" onClick={onClose} disabled={isSaving || formik.isSubmitting} className="btn-cancel">
          Cancel
        </Button>
        <Button variant="primary" onClick={() => formik.handleSubmit()} disabled={isSaving || formik.isSubmitting} className="btn-save">
          {isSaving || formik.isSubmitting ? "Saving..." : "Save"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditModal;
